export default {"src":"/_next/static/media/tripadvisor_logo.08948952.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};